import * as bootstrap from 'bootstrap'
import Plotly from 'plotly.js-dist'
// import { Marquee } from 'dynamic-marquee';
// import {tns} from 'tiny-slider/dist/tiny-slider'
// import 'tiny-slider/dist/tiny-slider.css'
import 'ol/ol.css'
import { Projection, addCoordinateTransforms, fromLonLat, transformExtent, get as getProjection } from 'ol/proj'
import { html, render } from 'lit-html'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-tour/build/css/bootstrap-tour.min.css'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import { Style, Fill, Stroke } from 'ol/style'
import ScaleLine from 'ol/control/ScaleLine'
import { Map, View, proj } from 'ol'

import Overlay from 'ol/Overlay'
import TileLayer from 'ol/layer/Tile'
import MVT from 'ol/format/MVT'
import TileWMS from 'ol/source/TileWMS'
import VectorTileLayer from 'ol/layer/VectorTile'
import VectorTileSource from 'ol/source/VectorTile'
import OSM from 'ol/source/OSM'
import XYZ from 'ol/source/XYZ'
import slick from 'slick-carousel/slick/slick.js'
import { defaults } from 'ol/control'
import proj4 from 'proj4'
import { register } from 'ol/proj/proj4'

import flatpickr from 'flatpickr'
// import monthSelect from "flatpickr/dist/plugins/monthSelect";
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
// import weekSelect from "flatpickr/dist/plugins/weekSelect/weekSelect";
// var Handlebars = require("handlebars")

// import pug from 'pug'
// var index_pug= require('./templates/index_help.pug')
// const index_html = index_pug({name:'title'})
// console.log(index_html)
import * as colormp from './js/colormaps.js'
import { plotTimeseries, plotPiechart, plotTimeseriesVector } from './js/popups.js'
import { createClassesLegend, createFlowLegend, createDescriptionBox, createLayerDescriptionBox, createMultipleFlowLegend } from './js/legends.js'
import { getIntro } from './js/intro.js'
import { layersGS, layersVts, PANSIMBABWE, PANSOUTHAFRICA, ZOOMSIMBABWE, ZOOMSOUTHAFRICA } from './js/layers.js'
// import { longtermDroughtRiskStrings,riskPopoverStrings} from './js/strings.js';
import * as strDb from './js/strings.js'
import { header, popoverButton, infoButtonTable } from './templates/template.js'

import { addListener } from 'cluster'
// import mproj from 'mproj'
var mproj = require('mproj')
// import {Sidebar} from './js/ol5-sidebar'
// import {$,jQuery} from 'jquery';
// export for others scripts to use
// window.$ = $;
// window.jQuery = jQuery;
window.$ = window.jQuery = require('jquery')

var container = document.getElementById('popup')
var content = document.getElementById('popup-content')
var closer = document.getElementById('popup-closer')
// console.log(content)

console.log(process.env.NODE_ENV)
console.log(process.env.GEOSERVER_PREFIX)
var GEOSERVER_PREFIX = process.env.GEOSERVER_PREFIX

console.log(GEOSERVER_PREFIX)
// var inDevelopmentMode = process.env.GEOSERVER_PATH
// console.log(process.env.GEOSERVER_PATH);
// if (inDevelopmentMode == "debug"){
//   console.log('dev-mode');
//   GEOSERVER_PREFIX = 'ooook'

// }

// render(header({data:'DATA',downloads:'DOWNLOADS'..,about:'ABOUT',title:'INTEGRATED DROUGHT TOOL'}),$('header'));
// render(header({ data: 'DATA', downloads: 'DOWNLOADS', about: 'ABOUT', title: 'INTEGRATED DROUGHT TOOL' }), document.getElementById('header'))
render(header({ data: 'DATA', about: 'ABOUT', title: 'INTEGRATED DROUGHT TOOL' }), document.getElementById('header'))
// render(info_button({title:'OK',subtitle:'Beautiful'},{title:'index',description:'It is nice'}),document.getElementById('global-regional'))
var riskPopover = popoverButton(
    infoButtonTable(
        strDb.riskPopoverStrings,
        []
    )
)
render(riskPopover, document.getElementById('risk-popover'))
var hazardPopover = popoverButton(
    infoButtonTable(
        strDb.hazardPopoverStrings,
        []
    )
)
render(hazardPopover, document.getElementById('hazard-popover'))

var vulnerabilityPopover = popoverButton(
    infoButtonTable(
        strDb.vulnerabilityPopover,
        []
    )
)
render(vulnerabilityPopover, document.getElementById('vulnerability-popover'))

var exposurePopover = popoverButton(
    infoButtonTable(
        strDb.exposurePopover,
        []
    )
)
render(exposurePopover, document.getElementById('exposure-popover'))

var impactPopover = popoverButton(
    infoButtonTable(
        strDb.impactPopover,
        []
    )
)
render(impactPopover, document.getElementById('impact-popover'))
// function test(text) {
//     return `
//     <div>
//     ${text}
//     </div>
//     `
// }
// render(test_template({text:'test'}),document.getElementById('header'))

// use custom ejfs fileloader

// var introguide = introJs().setOptions({
//   disableInteraction: true
// }).addSteps([
//   {
//     element: '#data-btn',
//     intro: 'Filter the data to display here',
//     position: 'bottom'
//   },
//   {
//     element: '#spatial-scale-container',
//     intro: 'Toggle between global or regional products here',
//     position: 'right'
//   },
//   {
//     element: '#date-container',
//     intro: 'Filter data by month and year here',
//     position: 'right'
//   },
//   {
//     element: '#indicator-container',
//     intro: 'Choose which indicators to include in the assessment here',
//     position: 'right'
//   },
//   {
//     element: '#downloads-btn',
//     intro: 'Download the current map items here',
//     position: 'bottom'
//   },
//   {
//     element: '#about-btn',
//     intro: 'Learn more about the project here',
//     position: 'bottom'
//   }
// ]
// )
// Onboarding
var showIntro = true
if (showIntro === true) {
    var introguide = getIntro()
    window.addEventListener('load', function () {
        introguide.start()
        var doneTour = localStorage.getItem('EventTour') === 'Completed'
        if (doneTour) {

        } else {
            introguide.start()

            introguide.oncomplete(function () {
                localStorage.setItem('EventTour', 'Completed')
            })

            introguide.onexit(function () {
                localStorage.setItem('EventTour', 'Completed')
            })
        }
    })
}

// Insantiate flatpickr
export var FlatpickerInstance = flatpickr('#date', {
    altInput: true,
    minDate: '01-01-1980',
    maxDate: '01-01-2020',
    plugins: [new MonthSelectPlugin({
        shorthand: true, // defaults to false
        dateFormat: 'F Y', // defaults to "F Y"
        altFormat: 'F Y', // defaults to "F Y"
        theme: 'light' // defaults to "light"})],

    })],
    onYearChange: function () {
        var flatpickrDate = FlatpickerInstance.formatDate(FlatpickerInstance.selectedDates[0], 'Y-m-d')
        toggleableLayerIds.forEach(function (key) {
            var layer = layersGS[key]
            if (layer.dateVisibility === 'month') {
                // console.log('data vts')
                if (layer.service === 'WMS') {
                    layer.layer.getSource().updateParams({ TIME: flatpickrDate })
                } else {
                    layer.layer.changed()
                }
            }
        })
    },
    onChange: function () {
        // most Grace data is at the middle of the month
        // for better rounding set the selected date also to the middle of the month
        // if these changes for the grace-data, this should be changed accordingly.
        FlatpickerInstance.selectedDates[0].setDate(15)
        var flatpickrDate = FlatpickerInstance.formatDate(FlatpickerInstance.selectedDates[0], 'Y-m-d')

        toggleableLayerIds.forEach(function (key) {
            var layer = layersGS[key]
            if (layer.dateVisibility === 'month') {
                if (layer.service === 'WMS') {
                    layer.layer.getSource().updateParams({ TIME: flatpickrDate })
                } else {
                    layer.layer.changed()
                }
            }
        })
        // hazardRainfedPixelTsLayer.changed()
        // zflVciImpactLayer.changed()
        // adqiQ50Layer.changed()
        // adqiQ80Layer.changed()
        // console.log(flatpickr_instance.currentYear + '15')
        // console.log(flatpickr_instance.formatDate(flatpickr_instance.selectedDates[0], 'Ym15'))
        // flatpickr_instance.config.plugins = []
    }
})

// define popup
export var overlay = new Overlay({
    element: container,
    autoPan: true,
    autoPanAnimation: {
        duration: 250
    }
})

/**
 * Add a click handler to hide the popup.
 * @return {boolean} Don't follow the href.
 */
closer.onclick = function () {
    overlay.setPosition(undefined)
    closer.blur()
    return false
}

const FARMING_SIMBABWE = 'farming_simbabwe'
const HAZARD_RAINFED_PIXEL_MONTHLY = 'hazard_rainfed_pixel_monthly'
const HAZARD_RAINFED_PIXEL_RHAZ = 'hazard_rainfed_pixel_rhaz'
const HAZARD_RAINFED_PIXEL_VULNERABILITY = 'hazard_rainfed_pixel_vulnerability'
const HAZARD_RAINFED_PIXEL_RISK = 'hazard_rainfed_pixel_risk'
const UNU_VULNERABILITY = 'janna_vulnerability'

proj4.defs('EPSG:54030', '+proj=robin +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs')
register(proj4)
// proj4.defs('EPSG:391141', '+proj=eqearth +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs')
// var equalEarth=mproj.pj_init('+proj=eqearth +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs')
// var equalEarth=mproj.pj_init('+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs')
// register(proj4)
// const swissProjection = getProjection('EPSG:54030')
// console.log(swissProjection)
// console.log(equalEarth)
const epsg3857 =
  '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs'
var equalearth = '+proj=eqearth +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs'
export const transform4326 = mproj(equalearth)
const transform3857 = mproj(epsg3857, equalearth)

console.log(transform4326)
const eqearth = new Projection({
    units: 'm',
    code: 'EPSG:391141'
})
console.log(eqearth)

addCoordinateTransforms(
    'EPSG:4326',
    eqearth,
    function (coordinate) {
        try {
            return transform4326.forward(coordinate)
        } catch (e) {
            return [undefined, undefined]
        }
    },
    function (coordinate) {
        try {
            return transform4326.inverse(coordinate)
        } catch (e) {
            return [undefined, undefined]
        }
    }
)
addCoordinateTransforms(
    'EPSG:3857',
    eqearth,
    function (coordinate) {
        try {
            return transform3857.forward(coordinate)
        } catch (e) {
            return [undefined, undefined]
        }
    },
    function (coordinate) {
        try {
            return transform3857.inverse(coordinate)
        } catch (e) {
            return [undefined, undefined]
        }
    }
)

var view = new View({
    // multiWorld:false,
    // projection: swissProjection,
    // projection:
    projection: eqearth,
    maxZoom: 10,
    // center: fromLonLat([109.580, -0.733]),
    center: fromLonLat([30.0, -18.0]),
    // projection: 'EPSG:4326',
    zoom: 5,
    minZoom: 2,
    extent: transformExtent([-180, -60, 180, 60], 'EPSG:4326', 'EPSG:3857')
})

var politicalBoundariesVts = new VectorTileSource({
    // projection: 'EPSG:54030',
    format: new MVT(),
    crossOrigin: 'Anonymous',
    url: GEOSERVER_PREFIX + '/geoserver/gwc/service/tms/1.0.0/globedrought:ne_10m_admin_0_countries' +
        // '@EPSG:900913' + '@pbf/{z}/{x}/{-y}.pbf',
        '@equal_earth' + '@pbf/{z}/{x}/{-y}.pbf',
    serverType: 'geoserver',
    maxZoom: 8
})
var politicalBoundariesLayer = new VectorTileLayer({
    title: 'political_boundaries',
    zIndex: 100,
    visible: true,
    maxZoom: 13,
    source: politicalBoundariesVts,
    style: function (feature) {
        return new Style({
            stroke: new Stroke({
                color: 'rgba(0,0,0,0.8)'
            })
        })
    }
})
var basemapEsriTopo = new TileLayer({
    source: new XYZ({
        crossOrigin: 'Anonymous',
        attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
            'rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
        // url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
            'World_Topo_Map/MapServer/tile/{z}/{y}/{x}'
    })
})

var scaleLineControl = new ScaleLine()
var mapLayers = []
mapLayers.push(politicalBoundariesLayer)
mapLayers.push(basemapEsriTopo)
for (const [key, value] of Object.entries(layersGS)) {
    mapLayers.push(layersGS[key].layer)
}
// console.log(mapLayers)
const map = new Map({
    target: 'map',
    // projection:"EPSG:32625",
    controls: defaults({
        // rotate: false,
        autoPan: true,
        attribution: false,
        zoom: true

    }),
    layers: mapLayers,
    view: view
})

// Setup our listener to process compeleted requests
function getPixelValueFromUrl (url, times, values, time) {
    // values.push(10)
    // times.push(time)
    // return 10
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.send()
    xhr.onreadystatechange = function () {
        // Only run if the request is complete
        // if (xhr.readyState !== 4) {
        //   // console.log("4")
        // };
        // Process our return data
        if (xhr.status >= 200 && xhr.status < 300) {
            // What do when the request is successful
            // console.log("200!")
            var pixelValue = JSON.parse(xhr.responseText).features[0].properties.GRAY_INDEX
            // console.log(pixelValue)
            // values.push(pixel_value)
            times.push(time)
            return pixelValue
            // values.set(time,pixel_value)
            // values[time]=pixel_value
        } else {
            // What to do when the request has failed
            // console.log('error', xhr);
        }
    }
}

map.on('singleclick', function (evt) {
    // console.log('Y' + FlatpickerInstance.currentYear+"_"+(FlatpickerInstance.currentMonth+1))
    // remove popup
    overlay.setPosition(undefined)
    closer.blur()
    // document.getElementById('info').innerHTML = '';
    var viewResolution = /** @type {number} */ (view.getResolution())

    toggleableLayerIds.forEach(function (key) {
        var layer = layersGS[key]
        if (layer.popupType === 'timeseriespopup') {
            console.log(layer.layer.getVisible())
            if (layer.layer.getVisible() === true) {
                // console.log(layer.layer)
                // console.log(layer.layer.getSource())
                plotTimeseries(evt, layer.layer.getSource(), overlay, view, GEOSERVER_PREFIX, layer.title)
            }
        }
        if (layer.popupType === 'timeseriespopupvector') {
            console.log(layer.layer.getVisible())
            if (layer.layer.getVisible() === true) {
                // console.log(layer.layer)
                // console.log(layer.layer.getSource())
                var features = map.getFeaturesAtPixel(evt.pixel)
                console.log(features)
                plotTimeseriesVector(evt, overlay, features, layer.title)
            }
        }
    })

    var features = map.getFeaturesAtPixel(evt.pixel)
    // if (features != null && layersGS.adqiQ50.layer.getVisible() === true) {
    //     // console.log('hzrd')
    //     overlay.setPosition(evt.coordinate)
    //     // content.innerHTML = features[0].get('CRHAZ_' + flatpickr_instance.currentYear) + '<br>'
    //     var props = features[0].properties_;
    //     // ['ADMIN', 'R_HARVAREA', 'GRIDCELLS', 'CODE_ISO', 'CRHAZ_8016'].forEach(element => delete props[element])
    //     ['COL', 'VULNERAB', 'GRIDCELLS', 'CODE_ISO', 'CRHAZ_8016'].forEach(element => delete props[element])

    //     var xLabels = Object.keys(props).map(function (x) { return x.replace('CRHAZ_', '') })
    //     // content.innerHTML = JSON.stringify(features[0].properties_) + '<br>'
    //     var trace1 = {
    //         x: xLabels,
    //         y: Object.values(props),
    //         type: 'scatter',
    //         line: { color: '#D69F1B' }
    //     }
    //     var layout = {
    //         title: layersGS.adqiQ50.title,
    //         yaxis: {
    //             showgrid: true,
    //             gridwidth: 1,
    //             gridcolor: 'grey'
    //         },
    //         xaxis: {
    //             showgrid: true,
    //             gridwidth: 1,
    //             gridcolor: 'grey'
    //         },
    //         width: 500,
    //         margin: { l: 50, r: 50, b: 50, t: 70 },
    //         shapes: [
    //             {
    //                 type: 'line',
    //                 yref: 'paper',
    //                 y0: 0,
    //                 y1: 1,
    //                 xref: 'x',
    //                 line: { dash: 'dashdot', color: 'grey' },
    //                 x0: FlatpickerInstance.currentYear,
    //                 x1: FlatpickerInstance.currentYear
    //                 //   x0: times[10],
    //                 //    x1: times[10],
    //             }
    //         ]
    //     }
    //     overlay.setPosition(evt.coordinate)
    //     Plotly.newPlot('popup-content', [trace1], layout)
    // }
    toggleableLayerIds.forEach(function (key) {
        var layer = layersGS[key]
        // console.log(layer.id)
        // console.log(layer.popupType)
        if (layer.popupType === 'piechartpopup') {
            // console.log('pie')
            if (features != null && layer.layer.getVisible()) {
                var props = features[0].properties_
                var labels = layer.popupLabels
                var values = [props.RISK_IRRI, props.RISK_RF]
                // console.log(labels)
                // console.log(values)
                plotPiechart(evt, values, labels, overlay, layer.title)
            }

            if (features != null && layersGS.unuVulnerability.layer.getVisible() === true) {
                // console.log('vuln')
                overlay.setPosition(evt.coordinate)
                // content.innerHTML = JSON.stringify(features[0].properties_) + '<br>'
                content.innerHTML = ''
                content.appendChild(unuVulnerabilityTable(features[0].properties_))
            }
        }
    })
})

map.addControl(scaleLineControl)
map.addOverlay(overlay)
var toggleableLayerIds = Object.keys(layersGS)
// console.log('layerIds')
// console.log(toggleableLayerIds)

// defaultDate does not work with monthlyPickr, so the date is here
FlatpickerInstance.setDate(new Date('2010-01-01T03:24:00'), true)

for (var ii = 0; ii < toggleableLayerIds.length; ii++) {
    var id = toggleableLayerIds[ii]
    // var mapLayers = map.getLayers().getArray()
    var link = document.createElement('a')

    link.id = id
    link.href = '#'
    link.className = 'menu-index'
    link.textContent = layersGS[id].title

    var HAZARD = 'hazard'
    var RISK = 'risk'
    var VULNERABILITY = 'vulnerability'
    var EXPOSURE = 'exposure'
    var IMPACT = 'impact'
    const NONE = 'none'
    const MONTH = 'month'
    const YEAR = 'year'
    link.onclick = function (e) {
        overlay.setPosition(undefined)
        closer.blur()
        /// Set Visibility
        var clickedLayer = this.id
        this.className = 'menu-index active'
        layersGS[clickedLayer].layer.setVisible(true)
        if (layersGS[clickedLayer].dateVisibility === NONE) {
            document.getElementById('flatpickr').style.opacity = 0.3
            document.getElementById('flatpickr').style.pointerEvents = 'none'
        } else if (layersGS[clickedLayer].dateVisibility === MONTH) {
            document.getElementById('flatpickr').style.opacity = 1
            document.getElementById('flatpickr').style.pointerEvents = 'auto'
        } else if (layersGS[clickedLayer].dateVisibility === YEAR) {
            document.getElementById('flatpickr').style.opacity = 1
            document.getElementById('flatpickr').style.pointerEvents = 'auto'
            // document.getElementsByClassName('flatpickr-monthSelect-months')[0].style.visibility='hidden'
        }

        if (document.getElementById(clickedLayer + '-legend') != null) {
            document.getElementById(clickedLayer + '-legend').style.visibility = 'visible'
        }

        if (document.getElementById(clickedLayer + '-description') != null) {
            document.getElementById(clickedLayer + '-description').style.visibility = 'visible'
            document.getElementById(clickedLayer + '-description').style.opacity = 1
        }
        // if ([FARMING_SIMBABWE, UNU_VULNERABILITY, RISK_COM_3, RISK_IRR_3, RISK_RAI_3].includes(layer.get('title'))) {
        //     view.animate({ zoom: 5, center: fromLonLat([29, -19]) })
        // }
        if (layersGS[clickedLayer].panTo !== undefined) {
            // console.log('pan')
            view.animate({ zoom: layersGS[clickedLayer].zoom, center: transform4326.forward(layersGS[clickedLayer].panTo) })
        }

        for (var o = 0; o < toggleableLayerIds.length; o++) {
            var layer = layersGS[toggleableLayerIds[o]]
            if (layer == null) {
                break
            }
            if (clickedLayer !== layer.id) {
                // console.log(layer)
                document.getElementById(layer.id).className = 'menu-index'
                layer.layer.setVisible(false)
                if (document.getElementById(layer.id + '-legend') != null) {
                    document.getElementById(layer.id + '-legend').style.visibility = 'hidden'
                }
                // Remove description box for the specific layer
                if (document.getElementById(layer.id + '-description') != null) {
                    document.getElementById(layer.id + '-description').style.visibility = 'hidden'
                    document.getElementById(layer.id + '-description').style.opacity = 0
                }
            }
            // var submentu = document.getElementById('submenu');
            // submentu.innerHTML = '';
        }
    }

    // console.log(layersGS[link.id].layerTypes[0])
    var layers = document.getElementById('menu-' + layersGS[link.id].layerTypes[0])
    layers.appendChild(link)
    // var layers = document.getElementById('sidebar');
    // layers.appendChild(link);
}

// Sidebar-logic
$('#data-btn').on('click', function (e) {
    $('#data-btn').toggleClass('active')
    if ($('#downloads-btn').hasClass('active')) {
        $('#downloads-btn').toggleClass('active')
        $('#sidebar-downloads').toggleClass('active')
    } else {
        $('.ol-scale-line').toggleClass('active')
        $('.description').toggleClass('active')
    }
    $('#sidebar').toggleClass('active')
    e.preventDefault()
})
$('#downloads-btn').on('click', function (e) {
    // var flatpickr_date = flatpickr_instance.formatDate(flatpickr_instance.selectedDates[0], "Y-m-d")
    // grace_layer.getSource().updateParams({ 'TIME': flatpickr_date })
    $('#downloads-btn').toggleClass('active')
    if ($('#data-btn').hasClass('active')) {
        $('#data-btn').toggleClass('active')
        $('#sidebar').toggleClass('active')
    } else {
        $('.ol-scale-line').toggleClass('active')
    }
    $('#sidebar-downloads').toggleClass('active')

    // $('#sidebar-downloads').toggleClass('active')
    e.preventDefault()
})

// $(document).tooltip({ selector: '[data-toggle="tooltip"]' });
$(document).popover({ selector: '[data-toggle="popover"]', html: true })
// remove popover at any other click
$('body').on('click', function (e) {
    // only buttons
    if ($(e.target).data('toggle') !== 'popover' &&
        $(e.target).parents('.popover.in').length === 0) {
        $('[data-toggle="popover"]').popover('hide')
    }
    // buttons and icons within buttons
    /*
  if ($(e.target).data('toggle') !== 'popover'
      && $(e.target).parents('[data-toggle="popover"]').length === 0
      && $(e.target).parents('.popover.in').length === 0) {
      $('[data-toggle="popover"]').popover('hide');
  }
  */
})
$('#risk-header').css('display', 'none')
$('#hazard-header').css('display', 'none')
$('#vulnerability-header').css('display', 'none')
$('#exposure-header').css('display', 'none')
$('#impact-header').css('display', 'block')
$('#impact-header').css('display', 'none')

function layerMenuVisibility () {
    var isRiskVisible = false
    var isHazardVisible = false
    var isVulnerabilityVisible = false
    var isExposureVisible = false
    var isImpactVisible = false
    var spatialExtent = $('input[name="spatial_radio"]:checked').val()
    var type = $('input[name="type_radio"]:checked').val()
    // console.log($('input[name="spatial_radio"]:checked').val())

    if ($('input[name="spatial_radio"]:checked').val() === 'regional_zw') {
        // view.animate({ zoom: ZOOMSIMBABWE, center: fromLonLat(PANSIMBABWE) })
        view.animate({ zoom: ZOOMSIMBABWE, center: transform4326.forward(PANSIMBABWE) })
    }
    if ($('input[name="spatial_radio"]:checked').val() === 'regional_za') {
        view.animate({ zoom: ZOOMSOUTHAFRICA, center: fromLonLat(PANSOUTHAFRICA) })
    }

    for (var o = 0; o < toggleableLayerIds.length; o++) {
        var id = toggleableLayerIds[o]
        $('#' + id).css('opacity', 0)
        $('#' + id).css('height', 0)
        $('#' + id).css('padding', 0)
        $('#' + id).css('border-bottom', 0)
        $('#' + id).css('visibility', 'hidden')
        // $('#' + id).css('display', 'none')
        for (var r = 0; r < layersGS[id].rainfedTypes.length; r++) {
            var rainfedType = layersGS[id].rainfedTypes[r]
            if (layersGS[id].spatialExtent === spatialExtent && rainfedType === type) {
                // if (layersGS[id].spatialExtent === spatialExtent && layersGS[id].rainfedTypes[0] === type) {
                $('#' + id).css('visibility', 'visible')
                $('#' + id).css('display', 'block')
                $('#' + id).css('opacity', 1)
                $('#' + id).css('height', 'auto')
                $('#' + id).css('padding', '0.3vh')
                $('#' + id).css('border-bottom', '1px solid rgba(0, 0, 0, 0.25)')

                if (layersGS[id].layerTypes[0] === RISK) {
                // if (rainfedType === RISK) {
                    isRiskVisible = true
                }
                if (layersGS[id].layerTypes[0] === HAZARD) {
                // if (rainfedType === HAZARD) {
                    isHazardVisible = true
                }
                if (layersGS[id].layerTypes[0] === VULNERABILITY) {
                // if (rainfedType === VULNERABILITY) {
                    isVulnerabilityVisible = true
                }
                if (layersGS[id].layerTypes[0] === IMPACT) {
                // if (rainfedType === IMPACT) {
                    isImpactVisible = true
                }
            } else {
            // if (global_regional[id] == spatial_extent) {
            // $('#' + id).css('display', 'none')
            }
        }
    }
    $('#no-data-available').css('display', 'block')
    if (isRiskVisible === true) {
        $('#no-data-available').css('display', 'none')
        $('#risk-header').css('display', 'block')
    } else {
        $('#risk-header').css('display', 'none')
    }
    if (isHazardVisible === true) {
        $('#no-data-available').css('display', 'none')
        $('#hazard-header').css('display', 'block')
    } else {
        $('#hazard-header').css('display', 'none')
    }
    if (isVulnerabilityVisible === true) {
        $('#no-data-available').css('display', 'none')
        $('#vulnerability-header').css('display', 'block')
    } else {
        $('#vulnerability-header').css('display', 'none')
    }
    if (isExposureVisible === true) {
        $('#no-data-available').css('display', 'none')
        $('#exposure-header').css('display', 'block')
    } else {
        $('#exposure-header').css('display', 'none')
    }
    if (isImpactVisible === true) {
        $('#no-data-available').css('display', 'none')
        $('#impact-header').css('display', 'block')
    } else {
        $('#impact-header').css('display', 'none')
    }
}
$('input[name="spatial_radio"]').change(function () {
    layerMenuVisibility()
})
$('input[name="type_radio"]').change(function () {
    layerMenuVisibility()
})

function riskLongtermTable (properties) {
    var table = document.createElement('table')
    var attributes = ['EXP_IRI', 'EXP_RF', 'EXP_TOT']
    attributes.forEach(function (attribute, index) {
        var tr = document.createElement('tr')
        var tdLeft = document.createElement('td')
        var tdRight = document.createElement('td')
        tdLeft.innerText = attribute
        tdRight.innerText = properties[attribute]
        tr.appendChild(tdLeft)
        tr.appendChild(tdRight)
        table.append(tr)
    })
    return table
}
function unuVulnerabilityTable (properties) {
    var table = document.createElement('table')
    var attributes = ['SOC_SUS', 'ECO_SUS', 'COP_CAP', 'TOT_VUL']
    var attributesDict = { SOC_SUS: 'Social Susceptibility', ECO_SUS: 'Ecosystem Susceptibility', COP_CAP: 'Lack of Coping Capacities', TOT_VUL: 'Total vulnerability' }
    // var attributes = Object.keys(properties)
    attributes.forEach(function (attribute, index) {
        var tr = document.createElement('tr')
        var tdLeft = document.createElement('td')
        var tdRight = document.createElement('td')
        tdLeft.className = 'popup-cell'
        tdRight.className = 'popup-cell'
        tdLeft.innerText = attributesDict[attribute]
        if (properties[attribute] === 0) {
            tdRight.innerText = "No data"
        } else {
            tdRight.innerText = properties[attribute].toFixed(3)
        }

        tr.appendChild(tdLeft)
        tr.appendChild(tdRight)
        tr.className = 'popup-cell'
        table.append(tr)
    })
    return table
}

toggleableLayerIds.forEach(function (key) {
    var layer = layersGS[key]
    // create description-box
    // console.log(key)
    document.body.append(createLayerDescriptionBox(layer))
    // create class-legend
    // console.log(key)
    if (layer.legendType === 'classlegend') {
        document.body.append(createClassesLegend(layer.classColorMap, layer.id + '-legend'))
    }
    if (layer.legendType === 'flowlegend') {
        console.log(layer.legendGradient)
        console.log(layer.legendValues)
        document.body.append(createFlowLegend(layer.legendGradient, layer.legendValues, layer.id + '-legend'))
    }
}
)

var opacityInput = $('#opacity-controller')
opacityInput.on('input change', function () {
    toggleableLayerIds.forEach(function (lay) {
        var layer = layersGS[lay]
        layer.layer.setOpacity(parseFloat(opacityInput.val()))
    })
})

// console.log('ready!')
// add legends
// Farming Simbabwe
// document.body.appendChild(createClassesLegend(layersGS.farming_simbabwe.class_to_color, FARMING_SIMBABWE + '-legend'), 'Farm')
// document.body.appendChild(createDescriptionBox(strDb.farmingSystemZimbabwe.name, strDb.farmingSystemZimbabwe.description, FARMING_SIMBABWE + '-description'))
// Hazard Rainfed pixel monthly
// document.body.appendChild(createFlowLegend('tg-gradient-hazard-color', ['0.4', '', '', '', '0.0', '', '', '', '-0.4'], HAZARD_RAINFED_PIXEL_MONTHLY + '-legend', layerNames[HAZARD_RAINFED_PIXEL_MONTHLY]))
// // document.body.appendChild(createDescriptionBox(strDb.hazardRainfedPixelMonthlyStrings.name, strDb.hazardRainfedPixelMonthlyStrings.description, HAZARD_RAINFED_PIXEL_MONTHLY + '-description'))

// // Hazard Rainfed country monthly (???)
// document.body.appendChild(createFlowLegend('tg-gradient-hazard-color', ['0.45', '', '', '', '', '', '', '', '0.25'], HAZARD_RAINFED_PIXEL_VULNERABILITY + '-legend', layerNames[HAZARD_RAINFED_PIXEL_MONTHLY]))
// // document.body.appendChild(createDescriptionBox(strDb.hazardRainfedCountryMonthlyStrings.name, strDb.hazardRainfedCountryMonthlyStrings.description, HAZARD_RAINFED_PIXEL_VULNERABILITY + '-description'))

// document.body.appendChild(createFlowLegend('tg-gradient-hazard-color', ['0.15', '', '', '', '0.0', '', '', '', '0.0'], HAZARD_RAINFED_PIXEL_RISK + '-legend', layerNames[HAZARD_RAINFED_PIXEL_RISK]))
// // document.body.appendChild(createDescriptionBox(strDb.hazardRainfedCountryMonthlyStrings.name, strDb.hazardRainfedCountryMonthlyStrings.description, HAZARD_RAINFED_PIXEL_RISK + '-description'))

// document.body.appendChild(createFlowLegend('tg-gradient-hazard-color', ['0.5', '', '', '', '0.25', '', '', '', '0'], HAZARD_RAINFED_PIXEL_RHAZ + '-legend', layerNames[HAZARD_RAINFED_PIXEL_MONTHLY]))
// document.body.appendChild(createFlowLegend('tg-gradient-risk-com-color', ['0.5', '', '', '', '', '', '', '', '0.3'], UNU_VULNERABILITY + '-legend', layerNames[UNU_VULNERABILITY]))

// $('#' + HAZARD_RAINFED_PIXEL_MONTHLY).click()
// $('#' + DSI).click()
$('#slick-logos').slick()
// uncheck radio buttons at startup
var inp = document.getElementsByTagName('input')
for (var ii = inp.length - 1; ii >= 0; ii--) {
    if (inp[ii].type === 'radio') inp[ii].checked = false
}
// show "forcast-not-available-modal"
$('#forcast-switch:checkbox').on('click', function () { $('#forcast-switch').prop('checked', false) })

// how to handle to many layers in scorlling indicator-container
// $('#indicator-container').scroll(function () {
//     var offset = $(this).scrollTop()
//     if (offset > 100) {
//         $('#indicator-container:not(.scrolled)').addClass('scrolled')
//     } else {
//         $('#indicator-container.scrolled').removeClass('scrolled')
//     }
// })

document.getElementById('export-png').addEventListener('click', function () {
    console.log('export')
    map.once('rendercomplete', function () {
        var mapCanvas = document.createElement('canvas')
        var size = map.getSize()
        mapCanvas.width = size[0]
        mapCanvas.height = size[1]
        var mapContext = mapCanvas.getContext('2d')
        Array.prototype.forEach.call(
            document.querySelectorAll('.ol-layer canvas'),
            function (canvas) {
                if (canvas.width > 0) {
                    var opacity = canvas.parentNode.style.opacity
                    mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity)
                    var transform = canvas.style.transform
                    // Get the transform parameters from the style's transform matrix
                    var matrix = transform
                        .match(/^matrix\(([^\(]*)\)$/)[1]
                        .split(',')
                        .map(Number)
                    // Apply the transform to the export map context
                    CanvasRenderingContext2D.prototype.setTransform.apply(
                        mapContext,
                        matrix
                    )
                    mapContext.drawImage(canvas, 0, 0)
                }
            }
        )
        if (navigator.msSaveBlob) {
        // link download attribuute does not work on MS browsers
            navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png')
        } else {
            var link = document.getElementById('image-download')
            link.href = mapCanvas.toDataURL()
            link.click()
        }
    })
    map.renderSync()
})
